import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import {
  Box,
  Button,
  Typography,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import style from "./style";
import { ReactComponent as Edit } from "../../../assets/invoice/blueedit.svg";
import { ReactComponent as Delete } from "../../../assets/invoice/redDelete.svg";
import Modal from "../../../components/Modal";
import Checkbox from "@mui/material/Checkbox";
import { CustomizedRadio } from "../../../components/CustomRadio";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import color from "../../../constants/color";
import { LoadingButton } from "@mui/lab";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#28AA4A",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },

}));

const additionalInformation = ({
  ScheduleData,
  setDpOpen,
  updateDepartment,
  handleDepartment,
  departmentData,
  deleteDepartment,
  dpopen,
  operatorData,
  operatorEmployees,
  roleOpen,
  setRoleOpen,
  getOperatorEmployees,
  createOperator,
  updateOperator,
  deleteOperator,
  handleScheduleTime,
  setOpen,
  loading,
  loadingUt,
  setUtOpen,
  updateLeaveType,
  updateUnitType,
  utopen,
  open,
  handleAccountLeaveType,
  handleUnitType,
  leaveData,
  unitData,
  deleteLeaveType,
  deleteUnitType,
  updateDeductionType,
  deductionData,
  deleteDeductionType,
  deductionOpen,
  setDeductionOpen,
  handleDeductionType,
  updateFringeType,
  fringeData,
  deleteFringeType,
  fringeOpen,
  setFringeOpen,
  handleFringeType,
  updateTaxYear,
  taxData,
  deleteTaxYear,
  taxOpen,
  setTaxOpen,
  handleTaxYear,
  handlePayslipShow,
  handlePayslipShowEmptyValues,
  payslipShow,
  updateHoliday,
  holiday,
  deleteHoliday,
  handleHoliday,
  holidayOpen,
  setHolidayOpen,
  getHolidayType,
  holidayTypes,
  payslipData,
  handlePayslip,
  allowanceType,
  allowanceOpen,
  setAllowanceOpen,
  handleAddAllowance,
  updateAllowanceType,
  deleteAllowanceType,
  contributionType,
  setContributionsOpen,
  contributionsOpen,
  handleAddContributions,
  updateContributions,
  deleteContributions,
  leviesTypes,
  handleAddLevies,
  updateLevies,
  deleteLevies,
  deleteCreditType,
  numberFormats,
  numberFormatsLoading,
  numberFormatsSaving,
  numberFormatErrors,
  isNumberFormatSaveDisabled,
  handleNumberFormatChange,
  handleNumberFormatSave,
  accountCountry,
  marketingReceive,
  updateMarketingNotification,
  marketingLoading,
}) => {
  const role = localStorage.getItem("role");
  const isSouthAfrica =
    String(role).toLowerCase() === "admin" &&
    String(accountCountry || "").trim() === "South Africa";
  const [leave, setLeave] = useState("");
  const [unit, setUnit] = useState("");
  const [department, setDepartment] = useState("");
  const [operatorName, setOperatorName] = useState("");
  const [operatorIsEmployee, setOperatorIsEmployee] = useState(false);
  const [operatorEmployee, setOperatorEmployee] = useState("");
  const [deduction, setDeduction] = useState("");
  const [fringe, setFringe] = useState("");
  const [allowance, setAllowance] = useState("");
  const [desc, setDesc] = useState("");
  const [tax, setTax] = useState(dayjs(null));
  const [end, setEnd] = useState(dayjs(null));
  const [holidayDate, setHolidayDate] = useState(dayjs(null));
  const [holidayEndDate, setHolidayEndDate] = useState(dayjs(null));
  const [holidayType, setHolidayType] = useState("");
  const [active, setActive] = useState(false);
  const [from, setFrom] = useState("");
  const [utfrom, setutFrom] = useState("");
  const [dpfrom, setdpFrom] = useState("");
  const [roleFrom, setRoleFrom] = useState("");
  const [editleave, setEditleave] = useState("");
  const [editDeduction, setEditDeduction] = useState("");
  const [editFringe, setEditFringe] = useState("");
  const [editAllowance, setEditAllowance] = useState("");
  const [editDepartment, setEditDepartment] = useState("");
  const [editOperator, setEditOperator] = useState("");
  const [editTax, setEditTax] = useState("");
  const [editHoliday, setEditHoliday] = useState("");
  const [editUnit, setUnitleave] = useState("");
  const [opens, setOpens] = useState(false);
  const [utOpens, setUtOpens] = useState(false);
  const [dltDp, setDltDp] = useState(false);
  const [dltRole, setDltRole] = useState(false);
  const [delContributions, setDelContributions] = useState(false);
  const [dltDeduction, setDltDeduction] = useState(false);
  const [dltFringe, setDltFringe] = useState(false);
  const [dltAllowance, setDelAllowance] = useState(false);
  const [dltTax, setDltTax] = useState(false);
  const [dltHoliday, setDltHoliday] = useState(false);
  const [dltShift, setDltShift] = useState(false);
  const [taxSettings, setTaxSettings] = useState(
    payslipData?.settings || []
  );
  const [payeName, setPayeName] = useState(payslipData?.paye?.name || "");
  const [value, setValue] = useState();
  const [utValue, setUtValue] = useState();
  const [dpValue, setDpValue] = useState();
  const [roleValue, setRoleValue] = useState();
  const [deductionValue, setDeductionValue] = useState();
  const [fringeValue, setFringeValue] = useState();
  const [taxValue, setTaxValue] = useState();
  const [holidayValue, setHolidayValue] = useState();
  const [Shiftvalue, setShiftValue] = useState();
  const [contributionVale, setContributionValue] = useState();
  const [fringeTax, setFringeTax] = useState(false);
  const [allowanceText, setAllowanceText] = useState(false);
  const [isShow, setisShow] = useState(false);

  const [leaveDays, setLeaveDays] = useState(true);
  const [showEmptyValues, setShowEmptyValues] = useState(true);
  const [companyEmail, setcompanyEmail] = useState(true);
  const [payslipNumber, setpayslipNumber] = useState(true);
  const [allDeductions, setallDeductions] = useState(true);
  const [empPassNo, setempPassNo] = useState(true);
  const [staffId, setstaffId] = useState(true);
  const [joiningDate, setjoiningDate] = useState(true);
  const [payFrequency, setpayFrequency] = useState(true);
  const [isdepartment, setIsDepartment] = useState(true);
  const [employeeEmail, setemployeeEmail] = useState(true);
  const [employeeAddress, setemployeeAddress] = useState(true);
  const [jobposition, setjobposition] = useState(true);
  const [bonus, setbonus] = useState(true);
  const [companyAddress, setcompanyAddress] = useState(true);
  const [totalTax, settotalTax] = useState(true);
  const [uif, setuif] = useState(true);
  const [sdl, setsdl] = useState(true);
  const [commission, setcommission] = useState(true);
  const [overTime, setoverTime] = useState(true);
  const [doubleOverTime, setdoubleOverTime] = useState(true);
  const [extraTime, setextraTime] = useState(true);
  const [overTimeHours, setoverTimeHours] = useState(true);
  const [doubleOverTimeHours, setdoubleOverTimeHours] = useState(true);
  const [extraTimeHours, setextraTimeHours] = useState(true);
  const [totalPension, settotalPension] = useState(true);
  const [totalDeductions, settotalDeductions] = useState(true);
  const [totalFringeBenefits, settotalFringeBenefits] = useState(true);
  const [totalLevies, settotalLevies] = useState(true);
  const [totalMedical, settotalMedical] = useState(true);
  const [totalAllowances, settotalAllowances] = useState(true);
  const [companyPhone, setCompanyPhone] = useState(true);
  const [isPaid, setIsPaid] = useState(false);
  const [allowanceValue, setAllowanceValue] = useState();
  const [editContribution, setEditContribution] = useState("");
  const [contribution, setContribution] = useState("");
  const [contributionText, setContributionText] = useState(false);
  const [leviesOpen, setLeviesOpen] = useState(false);
  const [levies, setLevies] = useState("");
  const [editLevies, setEditLevies] = useState("");
  const [leviesText, setLeviesText] = useState(false);
  const [leviesValue, setLeviesValue] = useState();
  const [deltLevies, setDeltLevies] = useState(false);
  const [credit, setCredit] = useState("");
  const [editCredit, setEditCredit] = useState("");
  const [deltCredit, setDeltCredit] = useState(false);


  const location = useLocation();
  const { isEditable, companyToken } = location.state || {};
  const isSuperAdmin = role === "SuperAdmin" || role === "superadmin";
  const numberFormatValues = numberFormats || {};
  const prefixErrors = numberFormatErrors || {};
  const MIN_PREFIX_LENGTH = 2;
  const MAX_PREFIX_LENGTH = 6;
  const MAX_COUNTER_LENGTH = 9;
  const PREFIX_ALLOWED_REGEX = /^[A-Z]+$/;

  const handlePrefixInput = (field) => (event) => {
    if (!handleNumberFormatChange) return;
    let value = event.target.value.toUpperCase();
    if (!PREFIX_ALLOWED_REGEX.test(value) && value !== "") {
      value = value.replace(/[^A-Z]/g, "");
    }
    if (value.length > MAX_PREFIX_LENGTH) {
      value = value.slice(0, MAX_PREFIX_LENGTH);
    }
    handleNumberFormatChange(field, value);
  };
  const handleCounterInput = (field) => (event) => {
    if (!handleNumberFormatChange) return;
    const rawValue = event.target.value.replace(/\D/g, "").slice(0, MAX_COUNTER_LENGTH);
    handleNumberFormatChange(field, rawValue);
  };
  const isNumberFormatDisabled =
    !isEditable || numberFormatsLoading || numberFormatsSaving;
  const DATE_FORMAT_OPTIONS = [
    { value: "DD/MM/YYYY", example: "01/05/2026" },
    { value: "DD/MM/YY", example: "01/05/26" },
    { value: "YYYY/MM/DD", example: "2026/05/01" },
    { value: "YY/MM/DD", example: "26/05/01" },
    { value: "DD MMM YYYY", example: "01 May 2026" },
    { value: "MMM DD, YYYY", example: "May 01, 2026" },
  ];
  const handleDateFormatChange = (event) => {
    if (!handleNumberFormatChange) return;
    handleNumberFormatChange("dateFormat", event.target.value);
  };
  const { showAlert } = useAlert();

  useEffect(() => {
    if (payslipShow) {
      setLeaveDays(payslipShow.leaveDays);
      setcompanyEmail(payslipShow.companyEmail);
      setpayslipNumber(payslipShow.payslipNumber);
      setCompanyPhone(payslipShow.companyPhone);
      setallDeductions(payslipShow.allDeductions);
      setempPassNo(payslipShow.empPassNo);
      setstaffId(payslipShow.staffId);
      setjoiningDate(payslipShow.joiningDate);
      setpayFrequency(payslipShow.payFrequency);
      setIsDepartment(payslipShow.department);
      setemployeeEmail(payslipShow.employeeEmail);
      setemployeeAddress(payslipShow.employeeAddress);
      setjobposition(payslipShow.jobposition);
      setbonus(payslipShow.bonus);
      setcompanyAddress(payslipShow.companyAddress);
      settotalTax(payslipShow.totalTax);
      setuif(payslipShow.uif);
      setsdl(payslipShow.sdl);
      setcommission(payslipShow.commission);
      setoverTime(payslipShow.overTime);
      setdoubleOverTime(payslipShow.doubleOverTime);

      setextraTime(payslipShow.extraTime);
      setoverTimeHours(payslipShow.overTimeHours);
      setdoubleOverTimeHours(payslipShow.doubleOverTimeHours);
      setextraTimeHours(payslipShow.extraTimeHours);

      settotalPension(payslipShow.totalPension);
      settotalDeductions(payslipShow.totalDeductions);
      settotalFringeBenefits(payslipShow.totalFringeBenefits);
      settotalMedical(payslipShow.totalMedical);
      settotalLevies(payslipShow.totalLevies);
      settotalAllowances(payslipShow.totalAllowances);
      setShowEmptyValues(payslipShow.showEmptyValues);
    }
  }, [payslipShow]);


  const handleShowEmptyValues = (field, value) => {
    if (field === "showEmptyValues") {
      setShowEmptyValues(value);
    }
  };

  const handleChangeSettings = (field, value) => {
    if (value == "true") {
      value = true;
    } else {
      value = false;
    }

    if (field === "leaveDays") {
      setLeaveDays(value);
    } else if (field === "companyEmail:") {
      setcompanyEmail(value);
    } else if (field === "payslipNumber") {
      setpayslipNumber(value);
    } else if (field === "allDeductions") {
      setallDeductions(value);
    } else if (field === "EmpPassNo") {
      setempPassNo(value);
    } else if (field === "staffId") {
      setstaffId(value);
    } else if (field === "joiningDate") {
      setjoiningDate(value);
    } else if (field === "payFrequency") {
      setpayFrequency(value);
    } else if (field === "isdepartment") {
      setIsDepartment(value);
    } else if (field === "employeeEmail") {
      setemployeeEmail(value);
    } else if (field === "employeeAddress") {
      setemployeeAddress(value);
    } else if (field === "jobposition") {
      setjobposition(value);
    } else if (field === "bonus") {
      setbonus(value);
    } else if (field === "companyAddress") {
      setcompanyAddress(value);
    } else if (field === "totalTax") {
      settotalTax(value);
    } else if (field === "uif") {
      setuif(value);
    } else if (field === "sdl") {
      setsdl(value);
    } else if (field === "commission") {
      setcommission(value);
    } else if (field === "overTime") {
      setoverTime(value);
    } else if (field === "doubleOverTime") {
      setdoubleOverTime(value);
    } else if (field === "extraTime") {
      setextraTime(value);
    } else if (field === "overTimeHours") {
      setoverTimeHours(value);
    } else if (field === "doubleOverTimeHours") {
      setdoubleOverTimeHours(value);
    } else if (field === "extraTimeHours") {
      setextraTimeHours(value);
    } else if (field === "totalPension") {
      settotalPension(value);
    } else if (field === "totalDeductions") {
      settotalDeductions(value);
    } else if (field === "totalFringeBenefits") {
      settotalFringeBenefits(value);
    } else if (field === "totalLevies") {
      settotalLevies(value);
    } else if (field === "totalMedical") {
      settotalMedical(value);
    } else if (field === "totalAllowances") {
      settotalAllowances(value);
    } else if (field === "companyPhone") {
      setCompanyPhone(value);
    }
  };

  const radioPayslip = [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" },
  ];

  const [scheduleShifts, setScheduleShifts] = useState();
  const [selectedShiftIndex, setSelectedShiftIndex] = useState("");

  useEffect(() => {
    if (ScheduleData) {
      const updatedShifts = ScheduleData.map((shiftData) => {
        return shiftData.week.map((dayData) => {
          const schedule = {
            monday: {
              start: dayData?.monday?.shift?.start || "",
              end: dayData?.monday?.shift?.end || "",
              lunchHour: dayData?.monday?.shift?.lunchHour || false,
              isShift: dayData?.monday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.monday?.shift?.start,
                dayData?.monday?.shift?.end,
                dayData?.monday?.shift?.lunchHour
              ),
            },
            tuesday: {
              start: dayData?.tuesday?.shift?.start || "",
              end: dayData?.tuesday?.shift?.end || "",
              lunchHour: dayData?.tuesday?.shift?.lunchHour || false,
              isShift: dayData?.tuesday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.tuesday?.shift?.start,
                dayData?.tuesday?.shift?.end,
                dayData?.tuesday?.shift?.lunchHour
              ),
            },
            wednesday: {
              start: dayData?.wednesday?.shift?.start || "",
              end: dayData?.wednesday?.shift?.end || "",
              lunchHour: dayData?.wednesday?.shift?.lunchHour || false,
              isShift: dayData?.wednesday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.wednesday?.shift?.start,
                dayData?.wednesday?.shift?.end,
                dayData?.wednesday?.shift?.lunchHour
              ),
            },
            thursday: {
              start: dayData?.thursday?.shift?.start || "",
              end: dayData?.thursday?.shift?.end || "",
              lunchHour: dayData?.thursday?.shift?.lunchHour || false,
              isShift: dayData?.thursday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.thursday?.shift?.start,
                dayData?.thursday?.shift?.end,
                dayData?.thursday?.shift?.lunchHour
              ),
            },
            friday: {
              start: dayData?.friday?.shift?.start || "",
              end: dayData?.friday?.shift?.end || "",
              lunchHour: dayData?.friday?.shift?.lunchHour || false,
              isShift: dayData?.friday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.friday?.shift?.start,
                dayData?.friday?.shift?.end,
                dayData?.friday?.shift?.lunchHour
              ),
            },
            saturday: {
              start: dayData?.saturday?.shift?.start || "",
              end: dayData?.saturday?.shift?.end || "",
              lunchHour: dayData?.saturday?.shift?.lunchHour || false,
              isShift: dayData?.saturday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.saturday?.shift?.start,
                dayData?.saturday?.shift?.end,
                dayData?.saturday?.shift?.lunchHour
              ),
            },
            sunday: {
              start: dayData?.sunday?.shift?.start || "",
              end: dayData?.sunday?.shift?.end || "",
              lunchHour: dayData?.sunday?.shift?.lunchHour || false,
              isShift: dayData?.sunday?.shift?.isShift || false,
              totalHour: calculateHoursWithLunch(
                dayData?.sunday?.shift?.start,
                dayData?.sunday?.shift?.end,
                dayData?.sunday?.shift?.lunchHour
              ),
            },
          };

          const checkedDays = {
            monday: !!dayData?.monday?.shift?.start,
            tuesday: !!dayData?.tuesday?.shift?.start,
            wednesday: !!dayData?.wednesday?.shift?.start,
            thursday: !!dayData?.thursday?.shift?.start,
            friday: !!dayData?.friday?.shift?.start,
            saturday: !!dayData?.saturday?.shift?.start,
            sunday: !!dayData?.sunday?.shift?.start,
          };

          const errors = {
            monday: { start: "", end: "" },
            tuesday: { start: "", end: "" },
            wednesday: { start: "", end: "" },
            thursday: { start: "", end: "" },
            friday: { start: "", end: "" },
            saturday: { start: "", end: "" },
            sunday: { start: "", end: "" },
          };

          return { schedule, checkedDays, errors };
        });
      });

      const flattenedShifts = updatedShifts.flat();
      setScheduleShifts(flattenedShifts);
    }
  }, [ScheduleData]);

  const calculateHours = (start, end) => {
    const timeFormat = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
    if (!timeFormat.test(start) || !timeFormat.test(end)) return "0.00";

    const [startHours, startMinutes] = start.split(":").map(Number);
    const [endHours, endMinutes] = end.split(":").map(Number);

    const startInMinutes = startHours * 60 + startMinutes;
    const endInMinutes = endHours * 60 + endMinutes;

    const diffInMinutes = endInMinutes - startInMinutes;
    return diffInMinutes > 0 ? (diffInMinutes / 60).toFixed(2) : "0.00";
  };

  const calculateHoursWithLunch = (start, end, lunchPaid) => {
    const timeFormat = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
    if (!timeFormat.test(start) || !timeFormat.test(end)) return "0.00";

    const [startHours, startMinutes] = start.split(":").map(Number);
    const [endHours, endMinutes] = end.split(":").map(Number);

    const startInMinutes = startHours * 60 + startMinutes;
    const endInMinutes = endHours * 60 + endMinutes;

    const diffInMinutes = endInMinutes - startInMinutes;
    if (diffInMinutes <= 0) return "0.00";

    let totalHours = diffInMinutes / 60;
    return lunchPaid
      ? totalHours.toFixed(2)
      : Math.max(totalHours - 1, 0).toFixed(2);
  };

  const handleChange = (day, type, value, index) => {
    setisShow(true);
    const timeFormat = /^(?:[0-9]|[01]\d|2[0-3]):[0-5]\d$/;
    setScheduleShifts((prevShifts) => {
      const updatedShifts = [...prevShifts];
      const schedule = updatedShifts[index].schedule;
      const errors = updatedShifts[index].errors;

      // Update the value
      schedule[day][type] = value;

      // Clear or set format error
      if (type !== "lunchHour" && type !== "isShift") {
        if (value === "") {
          errors[day][type] = "";
        } else if (!timeFormat.test(value)) {
          errors[day][type] = "Invalid time format (hh:mm)";
          // showAlert("Invalid time format (hh:mm)", "error");
        } else {
          errors[day][type] = "";
        }
      }

      // Validate start and end time
      const startTime = schedule[day]?.start;
      const endTime = schedule[day]?.end;

      if (timeFormat.test(startTime) && timeFormat.test(endTime)) {
        const [startHours, startMinutes] = startTime.split(":").map(Number);
        const [endHours, endMinutes] = endTime.split(":").map(Number);
        const startInMinutes = startHours * 60 + startMinutes;
        const endInMinutes = endHours * 60 + endMinutes;

        // Check if start and end times are the same
        if (startTime === endTime) {
          errors[day].end = "End time cannot be the same as start time";
          // showAlert("End time cannot be the same as start time", "error");
          schedule[day].totalHour = "";
        } else if (endInMinutes <= startInMinutes) {
          errors[day].end = "End time must be after start time";
          // showAlert("End time must be after start time", "error");
          schedule[day].totalHour = "";
        } else {
          errors[day].end = "";
          // Calculate total hours only if times are valid
          let totalHours = (endInMinutes - startInMinutes) / 60;
          schedule[day].totalHour = schedule[day]?.lunchHour
            ? totalHours
            : Math.max(totalHours - 1, 0);
        }
      } else if (type === "lunchHour" && schedule[day].totalHour) {
        // Recalculate total hours when lunch checkbox is toggled
        const startTime = schedule[day]?.start;
        const endTime = schedule[day]?.end;
        if (timeFormat.test(startTime) && timeFormat.test(endTime)) {
          const [startHours, startMinutes] = startTime.split(":").map(Number);
          const [endHours, endMinutes] = endTime.split(":").map(Number);
          const startInMinutes = startHours * 60 + startMinutes;
          const endInMinutes = endHours * 60 + endMinutes;
          let totalHours = (endInMinutes - startInMinutes) / 60;
          schedule[day].totalHour = schedule[day]?.lunchHour
            ? totalHours
            : Math.max(totalHours - 1, 0);
        }
      } else {
        schedule[day].totalHour = "";
      }

      return updatedShifts;
    });
  };


  const hasErrors = () => {
    return scheduleShifts.some((shift) =>
      weekDays.some((day) =>
        Object.values(shift.errors[day]).some((error) => error !== "")
      )
    );
  };


  const handleAddShift = (copyIndex = null) => {
    let newShift;

    if (
      copyIndex !== null &&
      copyIndex !== "" &&
      scheduleShifts?.[Number(copyIndex)]
    ) {
      // Deep clone so it's independent
      newShift = JSON.parse(JSON.stringify(scheduleShifts[Number(copyIndex)]));
    } else {
      newShift = {
        schedule: weekDays.reduce((acc, day) => {
          acc[day] = {
            start: "",
            end: "",
            lunchHour: false,
            totalHour: "0.00",
            isShift: false,
          };
          return acc;
        }, {}),
        checkedDays: weekDays.reduce((acc, day) => {
          acc[day] = false;
          return acc;
        }, {}),
        errors: weekDays.reduce((acc, day) => {
          acc[day] = { start: "", end: "" };
          return acc;
        }, {}),
      };
    }

    setScheduleShifts((prevShifts) => [...prevShifts, newShift]);
    setSelectedShiftIndex("");
  };

  const handleDeleteShift = (index) => {
    setScheduleShifts((prevShifts) =>
      prevShifts.filter((_, shiftIndex) => shiftIndex !== index)
    );
  };

  const handleScheduletimes = (scheduleShifts) => {
    const formattedData = scheduleShifts.map((item, index) => {
      const { schedule } = item;
      const formattedSchedule = {};

      Object.keys(schedule).forEach((day) => {
        formattedSchedule[day] = {
          shift: schedule[day],
        };
      });

      return {
        ...formattedSchedule,
      };
    });

    handleScheduleTime(formattedData);
  };
  const deleteDataShift = (item) => {
    setShiftValue(item);
  };

  const handleDeleteShifts = () => {
    handleDeleteShift(Shiftvalue);
    setDltShift(false);
  };

  const weekDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  useEffect(() => {
    if (payslipData && !Array.isArray(payslipData)) {
      setTaxSettings(
        (payslipData?.settings || []).map((item) => ({
          taxName: item?.taxName,
          isView: item?.isView || false,
          name: item?.name || "",
        }))
      );
      setPayeName(payslipData?.paye?.name || "");
    }
  }, [payslipData]);

  const handleTaxSettingChange = (taxName, field, value) => {
    setTaxSettings((prev) =>
      prev.map((item) =>
        item.taxName === taxName ? { ...item, [field]: value } : item
      )
    );
  };

  const deleteData = (item) => {
    setValue(item);
  };
  const deleteUtData = (item) => {
    setUtValue(item);
  };
  const deleteDpData = (item) => {
    setDpValue(item);
  };
  const deleteRoleData = (item) => {
    setRoleValue(item);
  };

  const getOperatorId = (item) => item?._id || item?.id;
  const getEmployeeId = (item) =>
    item?._id ||
    item?.id ||
    item?.employee?._id ||
    item?.employee?.id ||
    item?.employeeData?._id ||
    item?.employeeData?.id;
  const getEmployeeName = (item) => {
    const employee = item?.employee || item?.employeeData || item;
    const personalInfo = employee?.personalInfo || item?.personalInfo || {};
    const firstName = personalInfo?.firstName || item?.firstName || "";
    const lastName = personalInfo?.lastName || item?.lastName || "";
    const fullName = `${firstName} ${lastName}`.trim();

    return (
      fullName ||
      personalInfo?.email ||
      employee?.email ||
      item?.email ||
      employee?.name ||
      item?.name ||
      employee?.employeeName ||
      item?.employeeName ||
      "-"
    );
  };

  const isProtectedRole = (item) => {
    const name = (item?.name || "").trim().toLowerCase();
    return name === "employee" || item?.isDefault === true;
  };

  const roleTypeData = operatorData || [];

  const deleteContributionData = (item) => {
    setContributionValue(item);
  };

  const editContributinType = (item) => {
    setContributionsOpen(true);
    setFrom("edit");
    setEditContribution(item?._id);
    setContribution(item?.name);
  };

  const handleAddContributin = () => {
    setContributionsOpen(true);
    setFrom("create");
    setContribution("");
    setEditContribution(null);
  };

  const handleContributionDelete = () => {
    deleteContributions(contributionVale);
    setDelContributions(false);
  };

  const deleteDeductionData = (item) => {
    setDeductionValue(item);
  };
  const handleDeductionTypes = (deduction) => {
    handleDeductionType(deduction);
  };
  const editDeductionType = (item) => {
    setDeductionOpen(true);
    setFrom("edit");
    setEditDeduction(item?._id);
    setDeduction(item?.name);
  };
  const handleAddDeduction = () => {
    setDeductionOpen(true);
    setFrom("create");
    setDeduction("");
    setEditDeduction(null);
  };
  const handleDeductionDelete = () => {
    deleteDeductionType(deductionValue);
    setDltDeduction(false);
  };
  const deleteFringeData = (item) => {
    setFringeValue(item);
  };

  const deleteAllowanceData = (item) => {
    setAllowanceValue(item);
  };

  const deleteDeleteData = (item) => {
    setLeviesValue(item);
  };

  const handleFringeTypes = (fringe, fringeTax) => {
    handleFringeType(fringe, fringeTax);
  };
  const editFringeType = (item) => {
    setFringeOpen(true);
    setFrom("edit");
    setEditFringe(item?._id);
    setFringe(item?.name);
  };

  const editAllowanceType = (item) => {
    setAllowanceOpen(true);
    setFrom("edit");
    setEditAllowance(item?._id);
    setAllowance(item?.name);
  };

  const editLeviesType = (item) => {
    setLeviesOpen(true);
    setFrom("edit");
    setEditLevies(item?._id);
    setLevies(item?.name);
  };

  const handleAddFringe = () => {
    setFringeOpen(true);
    setFrom("create");
    setFringe("");
    setEditFringe(null);
  };

  const handleAddAllowanceType = () => {
    setAllowanceOpen(true);
    setFrom("create");
    setAllowance("");
    setEditAllowance(null);
  };

  const handleAddLeviesType = () => {
    setLeviesOpen(true);
    setFrom("create");
    setLevies("");
    setEditLevies(null);
  };

  const handleFringeDelete = () => {
    deleteFringeType(fringeValue);
    setDltFringe(false);
  };

  const handleAllowanceDelete = () => {
    deleteAllowanceType(allowanceValue);
    setDelAllowance(false);
  };

  const handleLeviesDelete = () => {
    deleteLevies(leviesValue);
    setDeltLevies(false);
  };

  const handleCreditDelete = () => {
    deleteCreditType();
    setDeltCredit(false);
  };

  const deleteTaxData = (item) => {
    setTaxValue(item);
  };
  const handleTaxYears = (tax, end) => {
    const endDate = dayjs(end).format("YYYY-MM-DD");
    const taxDate = dayjs(tax).format("YYYY-MM-DD");
    handleTaxYear(taxDate, endDate);
  };
  const editTaxYear = (item) => {
    setTaxOpen(true);
    setFrom("edit");
    setEditTax(item?._id);
    setTax(dayjs(item?.start));
    setEnd(dayjs(item?.end));
  };
  const handleAddTax = () => {
    setTaxOpen(true);
    setFrom("create");
    setTax(dayjs(""));
    setEnd(dayjs(""));
    setEditTax(null);
  };
  const handleTaxDelete = () => {
    deleteTaxYear(taxValue);
    setDltTax(false);
  };

  const deleteHolidayData = (item) => {
    setHolidayValue(item);
  };
  const handleHolidays = (start, end, type, desc) => {
    handleHoliday(start, end, type, desc);
  };
  const editHolidays = (item) => {
    setHolidayOpen(true);
    setFrom("edit");
    setEditHoliday(item?._id);
    setHolidayDate(dayjs(item?.start));
    setHolidayEndDate(dayjs(item?.end));
    setHolidayType(item?.type);
    setDesc(item?.desc);
  };
  const handleAddHoliday = () => {
    setHolidayOpen(true);
    setFrom("create");
    setHolidayDate(dayjs(""));
    setHolidayEndDate(dayjs(""));
    setHolidayType("");
    setDesc("");
    setEditHoliday(null);
    getHolidayType();
  };
  const handleHolidayDelete = () => {
    deleteHoliday(holidayValue);
    setDltHoliday(false);
  };
  const handleLeaveType = (leave, isPaid) => {
    handleAccountLeaveType(leave, isPaid);
  };
  const handleDepartments = (department, active) => {
    handleDepartment(department, active);
  };
  const handleOperators = async (name, isEmployee, employee, isActive) => {
    const payload = {
      name: name.trim(),
      isEmployee: Boolean(isEmployee),
      isActive: isActive !== undefined ? Boolean(isActive) : true,
    };

    if (isEmployee) {
      payload.employee = employee;
    }

    const result = await createOperator(payload);
    if (result?.success) {
      setRoleOpen(false);
    }
  };
  const editLeaveType = (item, index) => {
    setOpen(true);
    setFrom("edit");
    setEditleave(item?._id);
    setLeave(item?.type);
  };
  const editDepartments = (item) => {
    setDpOpen(true);
    setdpFrom("edit");
    setEditDepartment(item?._id);
    setDepartment(item?.name);
  };
  const editOperators = (item) => {
    if (isProtectedRole(item)) {
      showAlert("Employee role cannot be edited", "warning");
      return;
    }

    const operatorId = getOperatorId(item);
    if (!operatorId) {
      showAlert("Operator role is not available for editing yet", "warning");
      return;
    }

    setRoleOpen(true);
    setRoleFrom("edit");
    setEditOperator(operatorId);
    setOperatorName(item?.name || "");
    setOperatorIsEmployee(Boolean(item?.isEmployee));
    setOperatorEmployee(
      getEmployeeId(item?.employeeData) ||
      getEmployeeId(item?.employee) ||
      item?.employee ||
      ""
    );
    setActive(item?.isActive !== undefined ? item?.isActive : true);

    if (item?.isEmployee) {
      getOperatorEmployees();
    }
  };
  const handleAddOperator = () => {
    setRoleOpen(true);
    setRoleFrom("create");
    setOperatorName("");
    setOperatorIsEmployee(false);
    setOperatorEmployee("");
    setActive(true);
    setEditOperator(null);
  };
  const handleAddDepartment = () => {
    setDpOpen(true);
    setdpFrom("create");
    setDepartment("");
    setEditDepartment(null);
  };
  const handleUnitTypes = (unit) => {
    handleUnitType(unit);
  };
  const editUnitType = (item) => {
    setUtOpen(true);
    setutFrom("edit");
    setUnitleave(item?._id);
    setUnit(item?.name);
  };
  const handleAddLeaveType = () => {
    setOpen(true);
    setFrom("create");
    setLeave("");
    setEditleave(null);
  };

  const handleAddUnitType = () => {
    setUtOpen(true);
    setdpFrom("create");
    setUnit("");
    setUnitleave(null);
  };
  const handleDeleteItem = () => {
    deleteLeaveType(value);
    setOpens(false);
  };
  const handleUtDeleteItem = () => {
    deleteUnitType(utValue);
    setUtOpens(false);
  };
  const handleDpDelete = () => {
    deleteDepartment(dpValue);
    setDltDp(false);
  };
  const handleRoleDelete = () => {
    deleteOperator(roleValue);
    setDltRole(false);
  };

  return (
    <>
      <>
        <Box px="15px" mt={2}>
          <Box sx={style.headerContainer}>
            <Typography sx={style.leaveHeading}>
              Additional Information
            </Typography>
          </Box>
        </Box>
        <Box sx={style.numberFormatWrapper}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={style.numberFormatCard}>
                <Box>
                  <Typography sx={style.numberFormatTitle}>Employee ID / Number</Typography>
                  <Typography sx={style.numberFormatSubtitle}>
                    Configure the prefix and the next number used when creating new employees.
                  </Typography>
                </Box>
                <Grid container spacing={2} sx={style.numberFormatGrid}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      placeholder="EMP-"
                      value={numberFormatValues.employeePrefix || ""}
                      onChange={handlePrefixInput("employeePrefix")}
                      sx={style.numberFormatInput}
                      disabled={isNumberFormatDisabled}
                      error={Boolean(prefixErrors.employeePrefix)}
                      helperText={prefixErrors.employeePrefix}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AddCircleOutlineIcon sx={{ fontSize: 18, color: color.primary }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      placeholder="00001"
                      value={numberFormatValues.employeeCounter || ""}
                      onChange={handleCounterInput("employeeCounter")}
                      sx={style.numberFormatInput}
                      disabled={isNumberFormatDisabled}
                      error={Boolean(prefixErrors.employeeCounter)}
                      helperText={prefixErrors.employeeCounter}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                    />
                  </Grid>
                </Grid>
                <Typography sx={style.numberFormatHint}>
                  Numbers increment automatically each time a new employee is created.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={style.numberFormatCard}>
                <Box>
                  <Typography sx={style.numberFormatTitle}>PaySlip ID / Number</Typography>
                  <Typography sx={style.numberFormatSubtitle}>
                    Define how pay slip identifiers are generated for future runs.
                  </Typography>
                </Box>
                <Grid container spacing={2} sx={style.numberFormatGrid}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      placeholder="PS-"
                      value={numberFormatValues.payslipPrefix || ""}
                      onChange={handlePrefixInput("payslipPrefix")}
                      sx={style.numberFormatInput}
                      disabled={isNumberFormatDisabled}
                      error={Boolean(prefixErrors.payslipPrefix)}
                      helperText={prefixErrors.payslipPrefix}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AddCircleOutlineIcon sx={{ fontSize: 18, color: color.primary }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      placeholder="00001"
                      value={numberFormatValues.payslipCounter || ""}
                      onChange={handleCounterInput("payslipCounter")}
                      sx={style.numberFormatInput}
                      disabled={isNumberFormatDisabled}
                      error={Boolean(prefixErrors.payslipCounter)}
                      helperText={prefixErrors.payslipCounter}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                    />
                  </Grid>
                </Grid>
                <Typography sx={style.numberFormatHint}>
                  The next number will automatically increase after each pay slip is generated.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={style.numberFormatCard}>
                <Box>
                  <Typography sx={style.numberFormatTitle}>Date Format</Typography>
                  <Typography sx={style.numberFormatSubtitle}>
                    Choose how dates are displayed across the system.
                  </Typography>
                </Box>
                <Grid container spacing={2} sx={style.numberFormatGrid}>
                  <Grid item xs={12}>
                    <FormControl fullWidth error={Boolean(prefixErrors.dateFormat)}>
                      <Select
                        value={numberFormatValues.dateFormat || "DD/MM/YYYY"}
                        onChange={handleDateFormatChange}
                        disabled={isNumberFormatDisabled}
                        sx={style.numberFormatInput}
                      >
                        {DATE_FORMAT_OPTIONS.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Typography sx={style.numberFormatHint}>
                  Applies to dates shown throughout the system and on generated documents.
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box sx={style.numberFormatActions}>
            <LoadingButton
              variant="contained"
              color="success"
              sx={style.numberFormatSave}
              onClick={() => handleNumberFormatSave && handleNumberFormatSave()}
              disabled={!isEditable || isNumberFormatSaveDisabled}
              loading={numberFormatsSaving}
            >
              Save Number Formats
            </LoadingButton>
          </Box>
        </Box>
        {/* Marketing Notification */}
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Marketing Communication</Typography>
        </Box>

        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridboxTime}>
            <Grid container sx={style.payslip} alignItems="center">
              <Grid item xs={12} lg={2.5}>
                <Typography sx={style.gridTexts}>Receive Marketing Notifications</Typography>
              </Grid>
              <Grid item xs={12} lg={1}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: -4 }}>
                  <AntSwitch
                    checked={marketingReceive}
                    onChange={(e) => updateMarketingNotification(e.target.checked)}
                    disabled={marketingLoading || !isEditable}
                  />
                  <Typography sx={{ fontWeight: 500, color: color.text }}>
                    {marketingReceive ? "Yes" : "No"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} lg={6}></Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Leave Type</Typography>
          <Box sx={style.greyLine}></Box>
          {isSuperAdmin && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddLeaveType();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {leaveData &&
              leaveData?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.type || item?.typeName || item?.name || "—"}</Typography>
                  </Box>
                  {isSuperAdmin && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          editLeaveType(item, index);
                          setIsPaid(item?.isPaid);
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          deleteData(item?._id);
                          setOpens(true);
                        }}
                      >
                        <Delete />
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Unit Type</Typography>
          <Box sx={style.greyLineUnit}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddUnitType();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {unitData &&
              unitData?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>
                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editUnitType(item);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteUtData(item?._id);
                            setUtOpens(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Role Type</Typography>
          <Box sx={style.greyLineDepartment}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddOperator();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {roleTypeData &&
              roleTypeData?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>

                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          ...style.edit,
                          ...(isProtectedRole(item) && {
                            opacity: 0.5,
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }),
                        }}
                        onClick={() => {
                          if (isProtectedRole(item)) return;

                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editOperators(item);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={{
                          ...style.delete,
                          ...(isProtectedRole(item) && {
                            opacity: 0.5,
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }),
                        }}
                        onClick={() => {
                          if (isProtectedRole(item)) return;

                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else if (!getOperatorId(item)) {
                            showAlert(
                              "Operator role is not available for deleting yet",
                              "warning"
                            );
                          } else {
                            deleteRoleData(getOperatorId(item));
                            setDltRole(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Department Type</Typography>
          <Box sx={style.greyLineDepartment}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddDepartment();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {departmentData &&
              departmentData?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>

                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editDepartments(item);
                            setActive(item?.isActive);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteDpData(item?._id);
                            setDltDp(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Contribution Type</Typography>
          <Box sx={style.greyLinePension}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddContributin();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {contributionType &&
              contributionType?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>
                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editContributinType(item);
                            setContributionText(item?.isTaxable);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteContributionData(item?._id);
                            setDelContributions(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        {/* <Box sx={style.typeGrid}>
        <Typography sx={style.gridText}>Pension Type</Typography>
        <Box sx={style.greyLinePension}></Box>

        <Button variant="contained" type="submit" color="success" sx={style.jobButtons} onClick={() => { handleAddPension(); }}>
          + Add
        </Button>

      </Box>
      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={11.8} sx={style.gridbox}>
          {pensionData && pensionData?.map((item, index) => (

            <Box key={index} sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>{item?.name}</Typography>
              </Box>

              <Box sx={{ display: "flex" }}>
                <Box sx={style.edit} onClick={() => { editPensionType(item); }}><Edit /></Box>
                <Box sx={style.delete} onClick={() => { deletePensionData(item?._id), setDltPension(true); }}><Delete /> </Box>
              </Box>

            </Box>
          ))}


        </Grid>

      </Grid> */}

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Deduction Type</Typography>
          <Box sx={style.greyLineDepartment}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddDeduction();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {deductionData &&
              deductionData?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>
                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editDeductionType(item);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteDeductionData(item?._id);
                            setDltDeduction(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Fringe Type</Typography>
          <Box sx={style.greyLinePension}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddFringe();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {fringeData &&
              fringeData?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>
                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editFringeType(item);
                            setFringeTax(item?.isTaxable);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteFringeData(item?._id);
                            setDltFringe(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Allowance Type</Typography>
          <Box sx={style.greyLineDepartment}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddAllowanceType();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {allowanceType &&
              allowanceType?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>
                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editAllowanceType(item);
                            setAllowanceText(item?.isTaxable);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteAllowanceData(item?._id);
                            setDelAllowance(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Levies</Typography>
          <Box sx={style.greyLineDepartment}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddLeviesType();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {leviesTypes &&
              leviesTypes?.map((item, index) => (
                <Box key={index} sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <Typography sx={style.inputText}>{item?.name}</Typography>
                  </Box>
                  {isEditable && (
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={style.edit}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            editLeviesType(item);
                            setLeviesText(item?.isTaxable);
                          }
                        }}
                      >
                        <Edit />
                      </Box>
                      <Box
                        sx={style.delete}
                        onClick={() => {
                          if (item?.isSuperAdmin) {
                            showAlert(
                              "You don't have permission to access this resource",
                              "warning "
                            );
                          } else {
                            deleteDeleteData(item?._id);
                            setDeltLevies(true);
                          }
                        }}
                      >
                        <Delete />{" "}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Payslip View</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridboxTime}>
            {taxSettings.map((item) => (
              <Grid container sx={style.weakGrids} key={item.taxName}>
                <Grid item xs={12} lg={2}>
                  <Typography sx={style.gridTexts}>{item.taxName}</Typography>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <FormControlLabel
                    sx={style.formControlLabel}
                    control={
                      <Checkbox
                        checked={item.isView}
                        onChange={(e) =>
                          handleTaxSettingChange(
                            item.taxName,
                            "isView",
                            e.target.checked
                          )
                        }
                      />
                    }
                    disabled={!isEditable}
                    label="View On Payslip"
                  />
                </Grid>
                <Grid item xs={12} lg={3} sx={style.endTime}>
                  <InputLabel sx={style.label}>{item.taxName} Name</InputLabel>
                  <TextField
                    value={item.name}
                    onChange={(e) =>
                      handleTaxSettingChange(
                        item.taxName,
                        "name",
                        e.target.value
                      )
                    }
                    sx={style.reason}
                    disabled={!isEditable}
                  />
                </Grid>
              </Grid>
            ))}
            <Grid container sx={style.weakGrids}>
              <Grid item xs={12} lg={2}>
                <Typography sx={style.gridTexts}>Paye</Typography>
              </Grid>

              <Grid item xs={12} lg={3} sx={style.payeName}>
                <InputLabel sx={style.label}>Paye Name</InputLabel>
                <TextField
                  value={payeName}
                  onChange={(e) => setPayeName(e.target.value)}
                  disabled={!isEditable}
                  sx={style.reason}
                />
              </Grid>
            </Grid>
            {isEditable && (
              <Box sx={style.btnGrid}>
                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  sx={style.jobButtons}
                  onClick={() =>
                    handlePayslip(taxSettings, payeName, payslipData)
                  }
                >
                  Save
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Show Values on Payslip</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridboxTime}>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Zero Values</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleShowEmptyValues("showEmptyValues", event)
                  }
                  value={String(showEmptyValues)}
                  defaultChecked={showEmptyValues}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            {isEditable && (
              <Box sx={style.btnGrid}>
                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  sx={style.jobButtons}
                  onClick={() =>
                    handlePayslipShowEmptyValues({ showEmptyValues })
                  }
                >
                  Save
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Payslip Settings</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridboxTime}>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Company Email</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("companyEmail:", event)
                  }
                  value={String(companyEmail)}
                  defaultChecked={companyEmail}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Company Address</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("companyAddress", event)
                  }
                  value={String(companyAddress)}
                  defaultChecked={companyAddress}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Company Phone</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("companyPhone", event)
                  }
                  value={String(companyPhone)}
                  defaultChecked={companyPhone}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Employee Email</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("employeeEmail", event)
                  }
                  value={String(employeeEmail)}
                  defaultChecked={employeeEmail}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Employee Address</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("employeeAddress", event)
                  }
                  value={String(employeeAddress)}
                  defaultChecked={employeeAddress}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Emp ID/pass No </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("EmpPassNo", event)
                  }
                  value={String(empPassNo)}
                  defaultChecked={empPassNo}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Joining Date</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("joiningDate", event)
                  }
                  value={String(joiningDate)}
                  defaultChecked={joiningDate}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Department</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("isdepartment", event)
                  }
                  value={String(isdepartment)}
                  defaultChecked={isdepartment}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Job Position</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("jobposition", event)
                  }
                  value={String(jobposition)}
                  defaultChecked={jobposition}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Pay Frequency</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("payFrequency", event)
                  }
                  value={String(payFrequency)}
                  defaultChecked={payFrequency}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Payslip Number</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("payslipNumber", event)
                  }
                  value={String(payslipNumber)}
                  defaultChecked={payslipNumber}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Leave Days</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("leaveDays", event)
                  }
                  value={String(leaveDays)}
                  defaultChecked={leaveDays}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>All Deductions</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("allDeductions", event)
                  }
                  value={String(allDeductions)}
                  defaultChecked={allDeductions}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Staff Id</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("staffId", event)
                  }
                  value={String(staffId)}
                  defaultChecked={staffId}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Bonus</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) => handleChangeSettings("bonus", event)}
                  value={String(bonus)}
                  defaultChecked={bonus}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            {isSouthAfrica && (
              <>
                <Grid container sx={style.payslip}>
                  <Grid item xs={12} lg={2.1}>
                    <Typography sx={style.gridTexts}>UIF</Typography>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <CustomizedRadio
                      handleChange={(event) => handleChangeSettings("uif", event)}
                      value={String(uif)}
                      defaultChecked={uif}
                      radioLabel={radioPayslip}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={style.payslip}>
                  <Grid item xs={12} lg={2.1}>
                    <Typography sx={style.gridTexts}>SDL</Typography>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <CustomizedRadio
                      handleChange={(event) => handleChangeSettings("sdl", event)}
                      value={String(sdl)}
                      defaultChecked={sdl}
                      radioLabel={radioPayslip}
                    />
                  </Grid>
                </Grid>
              </>
            )}
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Commission</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("commission", event)
                  }
                  value={String(commission)}
                  defaultChecked={commission}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Over Time</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("overTime", event)
                  }
                  value={String(overTime)}
                  defaultChecked={overTime}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Over Time Hours</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("overTimeHours", event)
                  }
                  value={String(overTimeHours)}
                  defaultChecked={overTimeHours}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Double Over Time</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("doubleOverTime", event)
                  }
                  value={String(doubleOverTime)}
                  defaultChecked={doubleOverTime}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>
                  Double Over Time Hours
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("doubleOverTimeHours", event)
                  }
                  value={String(doubleOverTimeHours)}
                  defaultChecked={doubleOverTimeHours}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Extra Time</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("extraTime", event)
                  }
                  value={String(extraTime)}
                  defaultChecked={extraTime}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Extra Time Hours</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("extraTimeHours", event)
                  }
                  value={String(extraTimeHours)}
                  defaultChecked={extraTimeHours}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            {/* <Grid container sx={style.payslip}>
            <Grid item xs={12} lg={2}><Typography sx={style.gridTexts}>payslipNumber</Typography></Grid>
            <Grid item xs={12} lg={3}>
              <CustomizedRadio
                handleChange={(event) => handleChangeSettings("payslipNumber", event)}
                value={String(payslipNumber)}
                defaultChecked={payslipNumber} radioLabel={radioPayslip} />
            </Grid>
          </Grid> */}
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Total Pension</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalPension", event)
                  }
                  value={String(totalPension)}
                  defaultChecked={totalPension}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>

            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>
                  Total Fringe Benefits
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalFringeBenefits", event)
                  }
                  value={String(totalFringeBenefits)}
                  defaultChecked={totalFringeBenefits}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Total Levies</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalLevies", event)
                  }
                  value={String(totalLevies)}
                  defaultChecked={totalLevies}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Total Medical</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalMedical", event)
                  }
                  value={String(totalMedical)}
                  defaultChecked={totalMedical}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Total Allowances</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalAllowances", event)
                  }
                  value={String(totalAllowances)}
                  defaultChecked={totalAllowances}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Total Deductions</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalDeductions", event)
                  }
                  value={String(totalDeductions)}
                  defaultChecked={totalDeductions}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            <Grid container sx={style.payslip}>
              <Grid item xs={12} lg={2.1}>
                <Typography sx={style.gridTexts}>Total Tax</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomizedRadio
                  handleChange={(event) =>
                    handleChangeSettings("totalTax", event)
                  }
                  value={String(totalTax)}
                  defaultChecked={totalTax}
                  radioLabel={radioPayslip}
                />
              </Grid>
            </Grid>
            {isEditable && (
              <Box sx={style.btnGrid}>
                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  sx={style.jobButtons}
                  onClick={() =>
                    handlePayslipShow({
                      leaveDays,
                      companyEmail,
                      payslipNumber,
                      allDeductions,
                      empPassNo,
                      staffId,
                      joiningDate,
                      payFrequency,
                      employeeEmail,
                      totalAllowances,
                      totalMedical,
                      totalLevies,
                      totalFringeBenefits,
                      totalDeductions,
                      totalPension,
                      extraTimeHours,
                      doubleOverTimeHours,
                      overTimeHours,
                      extraTime,
                      doubleOverTime,
                      overTime,
                      commission,
                      sdl,
                      uif,
                      totalTax,
                      companyAddress,
                      bonus,
                      jobposition,
                      employeeAddress,
                      isdepartment,
                      companyPhone,
                    })
                  }
                >
                  Save
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Financial Year</Typography>
          <Box sx={style.greyLineDepartment}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddTax();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {taxData &&
              taxData.map((item, index) => {
                const startDate = item?.start ? dayjs(item?.start) : null;
                const endDate = item?.end ? dayjs(item?.end) : null;

                return (
                  <Box key={index} sx={style.inputSection}>
                    <Box sx={style.inputBoxLoan}>
                      <Box sx={{ mr: 2 }}>
                        <InputLabel sx={style.label}>Start</InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box>
                            <DatePicker
                              value={startDate}
                              slotProps={{
                                field: {
                                  readOnly: true,
                                },
                              }}
                              sx={style.calenderInput}
                            />
                          </Box>
                        </LocalizationProvider>
                      </Box>
                      <Box>
                        <InputLabel sx={style.label}>End</InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box>
                            <DatePicker
                              value={endDate}
                              slotProps={{
                                field: {
                                  readOnly: true,
                                },
                              }}
                              sx={style.calenderInput}
                            />
                          </Box>
                        </LocalizationProvider>
                      </Box>
                    </Box>
                    {isEditable && (
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={style.edit}
                          onClick={() => {
                            editTaxYear(item);
                          }}
                        >
                          <Edit />
                        </Box>
                        <Box
                          sx={style.delete}
                          onClick={() => {
                            deleteTaxData(item?._id);
                            setDltTax(true);
                          }}
                        >
                          <Delete />
                        </Box>
                      </Box>
                    )}
                  </Box>
                );
              })}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Holiday</Typography>
          <Box sx={style.greyLinePension}></Box>
          {isEditable && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={style.jobButtons}
              onClick={() => {
                handleAddHoliday();
              }}
            >
              + Add
            </Button>
          )}
        </Box>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {holiday &&
              holiday.map((item, index) => {
                const start = item?.start ? dayjs(item?.start) : null;
                const end = item?.end ? dayjs(item?.end) : null;
                const type = item?.type ? item?.type : null;

                return (
                  <Box key={index} sx={style.inputSection}>
                    <Box sx={style.inputBoxLoan}>
                      <Box sx={{ mr: 2 }}>
                        <InputLabel sx={style.label}>Start</InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box>
                            <DatePicker
                              value={start}
                              slotProps={{
                                field: {
                                  readOnly: true,
                                },
                                openPickerButton: {
                                  onClick: (e) => e.stopPropagation(),
                                },
                              }}
                              sx={style.calenderInput}
                            />
                          </Box>
                        </LocalizationProvider>
                      </Box>
                      <Box sx={{ mr: 2 }}>
                        <InputLabel sx={style.label}>End</InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box>
                            <DatePicker
                              value={end}
                              slotProps={{
                                field: {
                                  readOnly: true,
                                },
                                openPickerButton: {
                                  onClick: (e) => e.stopPropagation(),
                                },
                              }}
                              sx={style.calenderInput}
                            />
                          </Box>
                        </LocalizationProvider>
                      </Box>
                      <Box>
                        <InputLabel sx={style.label}>Type</InputLabel>
                        <TextField
                          sx={style.modalInput}
                          name="holidayType"
                          value={type}
                        />
                      </Box>
                    </Box>
                    {isEditable && (
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={style.edit}
                          onClick={() => {
                            editHolidays(item);
                          }}
                        >
                          <Edit />
                        </Box>
                        <Box
                          sx={style.delete}
                          onClick={() => {
                            deleteHolidayData(item?._id);
                            setDltHoliday(true);
                          }}
                        >
                          <Delete />
                        </Box>
                      </Box>
                    )}
                  </Box>
                );
              })}
          </Grid>
        </Grid>

        <Box sx={style.typeGrid}>
          <Typography sx={style.gridText}>Schedule Time</Typography>
        </Box>
        <Grid container sx={style.mainContainer}>
          {scheduleShifts?.map((shift, index) => (
            <Grid item xs={12} lg={11.8} sx={style.gridboxTime} key={index}>
              {isEditable && (
                <Box sx={style.dltSection}>
                  <Box
                    sx={style.deleteShift}
                    onClick={() => {
                      deleteDataShift(index), setDltShift(true);
                    }}
                  >
                    <Delete />
                  </Box>
                </Box>
              )}
              {weekDays.map((day) => (
                <Box sx={style.weakGrid} key={day}>
                  <Box sx={style.dayText}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={shift?.schedule?.[day]?.isShift || false}
                          onChange={(e) =>
                            handleChange(
                              day,
                              "isShift",
                              e.target.checked,
                              index
                            )
                          }
                        />
                      }
                      label={day.charAt(0).toUpperCase() + day.slice(1)}
                      disabled={!isEditable}
                    />
                  </Box>
                  <Box sx={style.formGrid}>
                    <Box sx={style.lunchTime}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={shift?.schedule?.[day]?.lunchHour}
                            onChange={(e) =>
                              handleChange(
                                day,
                                "lunchHour",
                                e.target.checked,
                                index
                              )
                            }
                            disabled={
                              !shift?.schedule?.[day]?.isShift || !isEditable
                            }
                          />
                        }
                        label="Lunch Paid"
                      />
                    </Box>
                    <Box>
                      <InputLabel sx={style.label}>Hours</InputLabel>
                      <TextField
                        value={Math.max(
                          Number(shift?.schedule?.[day]?.totalHour) || 0,
                          0
                        ).toFixed(2)}
                        sx={{
                          ...style.reason,
                          height: "70px",
                        }}
                        disabled={
                          !shift?.schedule?.[day]?.isShift || !isEditable
                        }
                      />
                    </Box>
                    <Box>
                      <InputLabel sx={style.label}>Start Time</InputLabel>
                      <TextField
                        value={shift?.schedule?.[day]?.start || ""}
                        onChange={(e) =>
                          handleChange(day, "start", e.target.value, index)
                        }
                        error={Boolean(shift?.errors?.[day]?.start)}
                        required
                        helperText={shift?.errors?.[day]?.start}
                        sx={{
                          ...style.reason,
                          height: "70px", // Adjust the height to include space for `helperText`
                        }}
                        disabled={
                          !shift?.schedule?.[day]?.isShift || !isEditable
                        }
                      />
                    </Box>

                    <Box sx={style.endTime}>
                      <InputLabel sx={style.label}>End Time</InputLabel>
                      <TextField
                        value={shift?.schedule?.[day]?.end || ""}
                        onChange={(e) =>
                          handleChange(day, "end", e.target.value, index)
                        }
                        error={Boolean(shift?.errors?.[day]?.end)}
                        required
                        helperText={shift?.errors?.[day]?.end}
                        sx={{
                          ...style.reason,
                          height: "70px", // Adjust the height to include space for `helperText`
                        }}
                        disabled={
                          !shift?.schedule?.[day]?.isShift || !isEditable
                        }
                      />
                    </Box>
                  </Box>
                </Box>
              ))}
            </Grid>
          ))}

          {isEditable && (
            <Box
              sx={{
                ...style.btnGrid,
                display: "flex",
                alignItems: "center",
                gap: 2, // add spacing between items
                flexWrap: { xs: "wrap", md: "nowrap" },
                mt: 2,
              }}
            >
              {scheduleShifts?.length < 3 && (
                <FormControl sx={{ minWidth: 150 }}>
                  <Select
                    value={selectedShiftIndex}
                    onChange={(e) => setSelectedShiftIndex(e.target.value)}
                    displayEmpty
                    fullWidth
                    sx={{
                      ...style.copyFromInput,
                      minWidth: 120,
                      mb: { xs: 1, md: 0 },
                    }}
                    renderValue={
                      selectedShiftIndex !== ""
                        ? undefined
                        : () => (
                          <span style={{ color: color.lightText }}>
                            Copy From
                          </span>
                        )
                    }
                  >
                    {scheduleShifts?.map((_, idx) => (
                      <MenuItem key={idx} value={idx}>
                        Shift {idx + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              <Button
                variant="contained"
                color="success"
                sx={{
                  ...style.jobButtonsShift,
                  minWidth: 120,
                  mb: { xs: 1, md: 0 },
                }}
                onClick={() => handleAddShift(selectedShiftIndex)}
                disabled={scheduleShifts?.length >= 3 || !isEditable}
              >
                Add Shift +
              </Button>

              <Button
                variant="contained"
                color="success"
                sx={{
                  ...style.jobButtonsShift,
                  minWidth: 120,
                  mb: { xs: 1, md: 0 },
                }}
                onClick={() => handleScheduletimes(scheduleShifts)}
                disabled={!isShow || hasErrors()}
              >
                Save
              </Button>
            </Box>
          )}
        </Grid>

        <Modal
          open={open}
          loading={loading}
          setOpen={setOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Leave Type"}
          handleCheck={() => {
            from === "edit"
              ? updateLeaveType(leave, editleave, isPaid)
              : handleLeaveType(leave, isPaid);
          }}
        >
          <Box sx={style.popupBox}>
            <Typography>
              {from === "edit" ? "Edit Leave Type" : "Add Leave Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="leave"
              value={leave}
              onChange={(e) => {
                setLeave(e.target.value);
              }}
            />
            <FormControlLabel
              control={<Checkbox />}
              checked={isPaid}
              defaultChecked={isPaid}
              onChange={(e) => setIsPaid(e.target.checked)}
              label="Is Paid"
            />
          </Box>
        </Modal>
        <Modal
          open={utopen}
          loading={loadingUt}
          setOpen={setUtOpen}
          btnText={utfrom === "edit" ? "Save Changes" : "Add New"}
          title={"Unit Type"}
          handleCheck={() => {
            utfrom === "edit"
              ? updateUnitType(unit, editUnit)
              : handleUnitTypes(unit);
          }}
        >
          <Box>
            <Typography>
              {utfrom === "edit" ? "Edit Unit Type" : "Add Unit Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="unit"
              value={unit}
              onChange={(e) => {
                setUnit(e.target.value);
              }}
            />
          </Box>
        </Modal>
        <Modal
          open={roleOpen}
          loading={loading}
          setOpen={setRoleOpen}
          btnText={roleFrom === "edit" ? "Save Changes" : "Add New"}
          title={"Role Type"}
          disabled={!operatorName.trim()}
          handleCheck={async () => {
            if (!operatorName.trim()) {
              showAlert("Role Type name is required", "error");
              return;
            }

            const payload = {
              name: operatorName.trim(),
              isEmployee: false,
              isActive: true,
            };

            if (roleFrom === "edit") {
              const result = await updateOperator(editOperator, payload);
              if (result?.success) {
                setRoleOpen(false);
              }
            } else {
              handleOperators(operatorName, false, "", true);
            }
          }}
        >
          <Box>
            <Typography>
              {roleFrom === "edit" ? "Edit Role Type" : "Add Role Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="operator"
              value={operatorName}
              onChange={(e) => {
                setOperatorName(e.target.value);
              }}
            />
          </Box>
        </Modal>
        <Modal
          open={dpopen}
          loading={loading}
          setOpen={setDpOpen}
          btnText={dpfrom === "edit" ? "Save Changes" : "Add New"}
          title={"Department"}
          handleCheck={() => {
            dpfrom === "edit"
              ? updateDepartment(department, active, editDepartment)
              : handleDepartments(department, active);
          }}
        >
          <Box>
            <Typography>
              {dpfrom === "edit" ? "Edit Department" : "Add Department"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="department"
              value={department}
              onChange={(e) => {
                setDepartment(e.target.value);
              }}
            />
          </Box>
          <Box>
            {/* <Typography>{dpfrom === "edit" ? "Set Department" : "Set Department"}</Typography> */}

            {/* <Select
            value={active}
            onChange={(event) => { setActive(event.target.value); }}
            name="active"
            sx={style.modalInput}
            displayEmpty
          >
            <MenuItem disabled value="">
              Select
            </MenuItem>
            <MenuItem sx={style.dropdown} value="true">Active</MenuItem>
            <MenuItem sx={style.dropdown} value="false">Inactive</MenuItem>
          </Select> */}

            <FormControlLabel
              control={<Checkbox />}
              checked={active}
              defaultChecked={active}
              onChange={(e) => setActive(e.target.checked)}
              label="Is Active"
            />
          </Box>
        </Modal>
        {/* <Modal open={pensionopen} loading={loading} setOpen={setPensionOpen} btnText={from === "edit" ? "Save Changes" : "Add New"} title={"Pension Type"} handleCheck={() => { from === "edit" ? updatePensionType(pension, editPension) : handlePensionTypes(pension); }}>
        <Box>
          <Typography>{from === "edit" ? "Edit Pension Type" : "Add Pension Type"}</Typography>
          <TextField sx={style.modalInput} name="pension" value={pension} onChange={(e) => { setPension(e.target.value); }} />
        </Box>

      </Modal> */}

        <Modal
          open={contributionsOpen}
          loading={loading}
          setOpen={setContributionsOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Contribution Type"}
          handleCheck={() => {
            from === "edit"
              ? updateContributions(
                contribution,
                editContribution,
                contributionText
              )
              : handleAddContributions(contribution, contributionText);
            setContributionsOpen(false);
          }}
        >
          <Box>
            <Typography>
              {from === "edit"
                ? "Edit Contribution Type"
                : "Add Contribution Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="pension"
              value={contribution}
              onChange={(e) => {
                setContribution(e.target.value);
              }}
            />
            <Grid item xs={12} lg={4}>
              <Box sx={style.inputSection}>
                <FormControlLabel
                  sx={style.formControlLabel}
                  control={<Checkbox checked={contributionText} />}
                  onChange={(e) => setContributionText(e.target.checked)}
                  label="Is Taxable"
                />
              </Box>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={deductionOpen}
          loading={loading}
          setOpen={setDeductionOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Deduction Type"}
          handleCheck={() => {
            from === "edit"
              ? updateDeductionType(deduction, editDeduction)
              : handleDeductionTypes(deduction);
          }}
        >
          <Box>
            <Typography>
              {from === "edit" ? "Edit Deduction Type" : "Add Deduction Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="deduction"
              value={deduction}
              onChange={(e) => {
                setDeduction(e.target.value);
              }}
            />
          </Box>
        </Modal>
        <Modal
          open={fringeOpen}
          loading={loading}
          setOpen={setFringeOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Fringe Type"}
          handleCheck={() => {
            from === "edit"
              ? updateFringeType(fringe, editFringe, fringeTax)
              : handleFringeTypes(fringe, fringeTax);
          }}
        >
          <Box>
            <Typography>
              {from === "edit" ? "Edit Fringe Type" : "Add Fringe Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="fringe"
              value={fringe}
              onChange={(e) => {
                setFringe(e.target.value);
              }}
            />
            <Grid item xs={12} lg={4}>
              <Box sx={style.inputSection}>
                <FormControlLabel
                  sx={style.formControlLabel}
                  control={<Checkbox />}
                  checked={fringeTax}
                  defaultChecked={fringeTax}
                  onChange={(e) => setFringeTax(e.target.checked)}
                  label="Is Taxable"
                />
              </Box>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={allowanceOpen}
          loading={loading}
          setOpen={setAllowanceOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Allowance Type"}
          handleCheck={() => {
            from === "edit"
              ? updateAllowanceType(allowance, editAllowance, allowanceText)
              : handleAddAllowance(allowance, allowanceText);
          }}
        >
          <Box>
            <Typography>
              {from === "edit" ? "Edit Allowance Type" : "Add Allowance Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="allowance"
              value={allowance}
              onChange={(e) => {
                setAllowance(e.target.value);
              }}
            />
            <Grid item xs={12} lg={4}>
              <Box sx={style.inputSection}>
                <FormControlLabel
                  sx={style.formControlLabel}
                  control={<Checkbox />}
                  checked={allowanceText}
                  defaultChecked={allowanceText}
                  onChange={(e) => setAllowanceText(e.target.checked)}
                  label="Is Taxable"
                />
              </Box>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={leviesOpen}
          loading={loading}
          setOpen={setLeviesOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Levies Type"}
          handleCheck={() => {
            from === "edit"
              ? updateLevies(levies, editLevies, leviesText)
              : handleAddLevies(levies, leviesText);
            setLeviesOpen(false);
          }}
        >
          <Box>
            <Typography>
              {from === "edit" ? "Edit Levies Type" : "Add Levies Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="Levies"
              value={levies}
              onChange={(e) => {
                setLevies(e.target.value);
              }}
            />
            <Grid item xs={12} lg={4}>
              <Box sx={style.inputSection}>
                <FormControlLabel
                  sx={style.formControlLabel}
                  control={<Checkbox />}
                  checked={leviesText}
                  defaultChecked={leviesText}
                  onChange={(e) => setLeviesText(e.target.checked)}
                  label="Is Taxable"
                />
              </Box>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={taxOpen}
          loading={loading}
          setOpen={setTaxOpen}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Loan Tax Year"}
          handleCheck={() => {
            from === "edit"
              ? updateTaxYear(tax, end, editTax)
              : handleTaxYears(tax, end);
          }}
        >
          <Box>
            {/* <Typography>{from === "edit" ? "" : "Add Loan Tax Year"}</Typography> */}
            <Box>
              <InputLabel sx={style.label}>Start</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    value={tax}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                    }}
                    sx={style.calenderInput}
                    error=""
                    onChange={(date) => {
                      setTax(date);
                    }}
                  />
                </Box>
              </LocalizationProvider>{" "}
            </Box>
            <Box>
              <InputLabel sx={style.label}>End</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    value={end}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                    }}
                    sx={style.calenderInput}
                    onChange={(date) => {
                      setEnd(date);
                    }}
                  />
                </Box>
              </LocalizationProvider>{" "}
            </Box>
          </Box>
        </Modal>
        <Modal
          open={holidayOpen}
          loading={loading}
          setOpen={setHolidayOpen}
          disabled={!holidayDate || !holidayEndDate || !holidayType || !desc}
          btnText={from === "edit" ? "Save Changes" : "Add New"}
          title={"Holiday"}
          handleCheck={() => {
            from === "edit"
              ? updateHoliday(
                holidayDate,
                holidayEndDate,
                holidayType,
                desc,
                editHoliday
              )
              : handleHolidays(holidayDate, holidayEndDate, holidayType, desc);
          }}
        >
          <Box>
            <Typography>
              {from === "edit" ? "Edit Holiday" : "Add Holiday"}
            </Typography>
            <Box>
              <InputLabel sx={style.label}>Start Date</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    value={holidayDate}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: {
                        size: "small",
                        error: false,
                      },
                      popper: {
                        sx: {
                          "& .MuiPaper-root": {
                            transform: "scale(0.8)", // Shrink the entire pop-up
                          },
                        },
                      },
                      layout: {
                        sx: {
                          "& .MuiPickersCalendarHeader-root": {
                            fontSize: "12px",
                          },
                          "& .MuiDayCalendar-weekDayLabel": {
                            fontSize: "10px",
                          },
                          "& .MuiPickersDay-root": {
                            fontSize: "12px",
                            height: "28px",
                          },
                        },
                      },
                    }}
                    disabled={!isEditable}
                    onChange={(date) => {
                      setHolidayDate(date ? dayjs(date).utc(true) : null);
                    }}
                  />
                </Box>
              </LocalizationProvider>
            </Box>
            <Box>
              <InputLabel sx={style.label}>End Date</InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                  <DatePicker
                    value={holidayEndDate}
                    disabled={!isEditable}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: {
                        size: "small",
                        error: false,
                      },
                      popper: {
                        sx: {
                          "& .MuiPaper-root": {
                            transform: "scale(0.8)",
                          },
                        },
                      },
                      layout: {
                        sx: {
                          "& .MuiPickersCalendarHeader-root": {
                            fontSize: "12px",
                          },
                          "& .MuiDayCalendar-weekDayLabel": {
                            fontSize: "10px",
                          },
                          "& .MuiPickersDay-root": {
                            fontSize: "12px",
                            height: "28px",
                          },
                        },
                      },
                    }}
                    onChange={(date) => {
                      setHolidayEndDate(date ? dayjs(date).utc(true) : null);
                    }}
                  />
                </Box>
              </LocalizationProvider>
            </Box>

            <Box>
              <FormControl
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "2.8em",
                    marginTop: "0.5em",
                    borderRadius: "10px",
                  },
                }}
              >
                <Typography shrink={true} sx={style.label}>
                  Holiday Type{" "}
                </Typography>

                <Select
                  value={holidayType}
                  onChange={(e) => {
                    setHolidayType(e.target.value);
                  }}
                  name="holidayType"
                  sx={style.dropdown}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>

                  {holidayTypes?.map((item, index) => (
                    <MenuItem
                      key={index}
                      sx={style.dropdown}
                      value={item?.name}
                    >
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box>
              <InputLabel sx={style.label}>Description</InputLabel>

              <TextField
                sx={style.modalInput}
                name="desc"
                value={desc}
                onChange={(e) => {
                  setDesc(e.target.value);
                }}
              />
            </Box>
          </Box>
        </Modal>
        <Modal
          open={opens}
          setOpen={setOpens}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Leave"}
          handleDelete={handleDeleteItem}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={utOpens}
          setOpen={setUtOpens}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Unit Type"}
          handleDelete={handleUtDeleteItem}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={dltRole}
          setOpen={setDltRole}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Role Type"}
          handleDelete={handleRoleDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={dltDp}
          setOpen={setDltDp}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Department"}
          handleDelete={handleDpDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        {/* <Modal open={dltPension} setOpen={setDltPension} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Pension Type"} handleDelete={handlePensionDelete}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal> */}
        <Modal
          open={dltDeduction}
          setOpen={setDltDeduction}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Deduction Type"}
          handleDelete={handleDeductionDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={dltFringe}
          setOpen={setDltFringe}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Fringe Type"}
          handleDelete={handleFringeDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>

        <Modal
          open={dltAllowance}
          setOpen={setDelAllowance}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Allowance Type"}
          handleDelete={handleAllowanceDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={dltTax}
          setOpen={setDltTax}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Tax Year"}
          handleDelete={handleTaxDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={dltHoliday}
          setOpen={setDltHoliday}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Holiday"}
          handleDelete={handleHolidayDelete}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
        <Modal
          open={dltShift}
          setOpen={setDltShift}
          deletetText={"Delete"}
          cancelText={"Cancel"}
          title={"Delete Shift"}
          handleDelete={handleDeleteShifts}
        >
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
      </>
      <Modal
        open={delContributions}
        setOpen={setDelContributions}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Contribution Type"}
        handleDelete={handleContributionDelete}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>

      <Modal
        open={deltLevies}
        setOpen={setDeltLevies}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Levies"}
        handleDelete={handleLeviesDelete}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>

      <Modal
        open={deltCredit}
        setOpen={setDeltCredit}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Credit Type"}
        handleDelete={handleCreditDelete}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>

    </>
  );
};
export default additionalInformation;
